import type { Shape } from '~/types/grid.types'
import { SHAPE_IDS } from './shapesIdsFreeform'

export const ENGRAVED_1X1_FREEFORM_SHAPES: Shape[] = [
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_BACK_SLASH,
    icon: 'EngravedBackSlash',
    prefix: 'Slash',
    label: 'Slash',
    w: 120,
    h: 120,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_FORWARD_SLASH,
        icon: 'EngravedBackSlash',
        prefix: 'Slash',
        label: 'Forward Slash',
        w: 120,
        h: 120,
        rotation: 90,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_CROSS,
    icon: 'EngravedCross',
    prefix: 'Cross',
    label: 'Cross',
    w: 120,
    h: 120,
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_FOUR_SQUARE,
    icon: 'EngravedFourSquare',
    prefix: '4Square',
    label: 'Four Square',
    w: 120,
    h: 120,
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_PARALLEL,
    icon: 'EngravedParallel',
    prefix: 'Parallel',
    label: 'Parallel',
    w: 120,
    h: 120,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_PARALLEL_VERTICAL,
        icon: 'EngravedParallel',
        prefix: 'Parallel',
        label: 'Parallel Vertical',
        w: 120,
        h: 120,
        rotation: 90,
      },
    ],
  },
]
